/**
 * @name Img_Text
 * @function
 * @description 이미지텍스트
 */

interface ImgTextProps {
  title: string;
  text: string;
}

export const ImgText = (props: ImgTextProps): JSX.Element => {
  return (
    <div
      className="bg-cover flex justify-end flex-col h-[24rem] sm:h-[35rem]"
      style={{
        backgroundImage: `url('http://choihyu.com/image/${props.title.toLowerCase()}.jpg')`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundSize: "cover",
      }}
    >
      <div className="px-10 py-4 font-semibold text-white">
        <p className="py-3 text-4xl sm:text-6xl sm:py-6">{props.title}</p>
        <p className="py-3 text-xl sm:text-2xl sm:py-6">{props.text}</p>
      </div>
    </div>
  );
};
